/* unplugin-vue-components disabled */import script from "./netplatform-prodkeymodal.vue?vue&type=script&setup=true&lang=js"
export * from "./netplatform-prodkeymodal.vue?vue&type=script&setup=true&lang=js"

import "./netplatform-prodkeymodal.vue?vue&type=style&index=0&id=bfe328ea&lang=scss"

const __exports__ = script;

export default __exports__